import React from "react"
import * as R from 'ramda'
import { HeartFilled } from '@ant-design/icons'
import Link from './link';
import { withTranslation } from "react-i18next";
import Image from "./image";
import {LogoIcon} from "./icons";
import { ga4 } from "../handlers/google-analytic";
import { getGG } from "../state/store";
import { datadogRum } from '@datadog/browser-rum'

const PrivilegeHome = ({ t, data, type, onRemoveFavorite = R.identity, onAddFavorite = R.identity }) => (
  <div className={'privilege-home'}>
    <ul>
      {
        data.map((privilege) => (
          <li key={ privilege.privilegeCode }>
            {
              type === 'favorite' && !privilege.isRemoved &&
              <HeartFilled
                className={'favorite-icon favorite-selected'}
                onClick={(e) => { e.stopPropagation(); onRemoveFavorite(privilege) }}
              />
            }
            {
              type === 'favorite' && privilege.isRemoved &&
              <HeartFilled
                className={'favorite-icon'}
                onClick={(e) => { e.stopPropagation(); onAddFavorite(privilege) }}
              />
            }
            <Link
              to={privilege.isPrivilegeGroup ? "/package/privilege-group-list" : "/privilege-detail"}
              // state={privilege.isPrivilegeGroup && privilege.privilegeGroupCode
              //   ? { privilegeGroupCode: privilege.privilegeGroupCode } 
              //   : { privilegeCode: privilege.privilegeCode }
              // }
              state={{ privilegeCode: privilege.privilegeCode }}
              button_id='privilegeThumbnailButtonId'
              onClick={() => {
                const { user } = getGG().store.getState()

                datadogRum.addAction('log_FE_user.getState', {
                  user: user
                })

                ga4.gtag('event', 'privilege_thumbnail', {
                  name: privilege.title,
                  category: 'thumbnail',
                  trigger: `privilegeThumbnailButtonId-${privilege.title}`,
                  profile_id: user.profileId
                })
              }}
            >
              <div className={'privilege-image'}>
                <Image PlaceholderComponent={
                  <div
                    className={'coupon-wisdom-logo-box with-placeholder'}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <LogoIcon svg={{ height: '4em', className: 'coupon-wisdom-logo' }}/>
                  </div>}
                  src={privilege.imgPrivilege}
                />
                {
                  privilege.status === 'Expired' && <>
                    <div className={'privilege-expired-box'} />
                    <div className={'privilege-expired-text'}>{t('privilege_expired')}</div>
                  </>
                }
                {
                  (privilege.status === 'Redeemed' || privilege.status === 'FullyRedeemed') && <>
                    <div className={'privilege-redeemed-box'} />
                    <div className={'privilege-redeemed-text'}>
                      {t(privilege.status === 'FullyRedeemed' ? 'package_privilege_fully_redeemed' : 'package_privilege_redeemed')}
                    </div>
                  </>
                }
              </div>
              <div className={'privilege-title'}>{ privilege.brandName }</div>
              <div className={'privilege-detail'}>{ privilege.title }</div>
              <div className={'privilege-date'}>{ privilege.date }</div>
            </Link>
          </li>
        ))
      }
    </ul>
  </div>
)

export default withTranslation()(PrivilegeHome)
